<template>
  <div class="lphero">
    <div class="lphero__content">
      <h4 class="lphero__title">
        Start this cyber security learning path - {{ learningPath.name }}
      </h4>
      <h2 class="lphero__name">{{ nextCourse.name }}</h2>
      <div class="lphero__actions">
        <div class="lphero__cta-wrapper">
          <router-link
            class="lphero__link lphero__fallback-link btn btn--primary"
            :to="courseLink"
          >
            Start First Course
          </router-link>
          <router-link :to="$buildContentLink('path', learningPath)">
            <button class="lphero__explore-lp lphero__link btn btn--secondary">
              Explore Learning Path
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CONSTANTS from '@/constants'
import { defineComponent, ref } from '@vue/composition-api'

export default defineComponent({
  name: 'Resume',
  setup() {
    const learningPath = CONSTANTS.HOME_PAGE.FALLBACK_CONTENT.LEARNING_PATH

    const nextCourse = CONSTANTS.HOME_PAGE.FALLBACK_CONTENT.COURSE

    const courseLink = ref({
      name: `learning-area-course`,
      params: {
        id: nextCourse.id,
        area: 'CyberSecurity',
        slug: nextCourse.slug,
      },
    })

    return {
      learningPath,
      nextCourse,
      courseLink,
    }
  },
})
</script>
